'use client';

import { useAction } from '@reatom/npm-react';
import { setVisitorAction } from '@trwl/store/actions';
import { PropsWithChildren, useEffect } from 'react';

export const VisitorIdProvider = ({ children }: PropsWithChildren) => {
  const setVisitor = useAction(setVisitorAction);
  useEffect(() => {
    setVisitor();
  }, [setVisitor]);
  return <>{children}</>;
};
